import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Checkbox,
  Form,
  Select,
} from 'semantic-ui-react';

class FormOptionsFormatOutput extends Component {
  constructor() {
    super();

    this.state = {
      showOptionsControls: false,
    };
  }

  toggleShowOptionsControls = () => {
    this.setState(prevState => ({ showOptionsControls: !prevState.showOptionsControls }));
  }

  renderOutputOptions = () => {
    const { data, updateDataField } = this.props;
    return (
      <div>
        <Form.Field
          control={Select}
          onChange={
          (event, eventData) => { updateDataField('format', eventData.value); }
        }
          value={data.format || ''}
          label="Format"
          options={[
            { text: 'None Specified', value: '', className: 're is-color-grey' },
            { text: 'Remeeting', value: 'remeeting' },
            { text: 'IBM/Watson', value: 'watson' },
          ]}
        />
        <Form.Field>
          <Checkbox
            toggle
            disabled={data.format === 'remeeting'}
            label="Show word alternatives"
            onChange={
            (event, eventData) => { updateDataField('word_alternatives', eventData.checked); }
          }
            checked={data.word_alternatives || false}
          />
        </Form.Field>
        <Form.Field>
          <Form.Field
            control={Select}
            onChange={
            (event, eventData) => { updateDataField('word_alternatives_threshold', eventData.value); }
          }
            value={data.word_alternatives_threshold}
            label="Word Alternatives Threshold"
            disabled={data.format === 'remeeting'}
            options={[
              { text: 'None Specified', value: '', className: 're is-color-grey' },
              { text: '0.00001', value: 0.00001 },
              { text: '0.0001', value: 0.0001 },
              { text: '0.001', value: 0.001 },
              { text: '0.01', value: 0.01 },
              { text: '0.1', value: 0.1 },
              { text: '0.9', value: 0.9 },
            ]}
          />
        </Form.Field>
        <Form.Field>
          <Checkbox
            toggle
            label="Show speaker labels detected for each word interval"
            disabled={data.format === 'remeeting'}
            onChange={
            (event, eventData) => { updateDataField('speaker_labels', eventData.checked); }
          }
            checked={data.speaker_labels || false}
          />
        </Form.Field>
        <Form.Field>
          <Checkbox
            toggle
            label="Show start and end times for each word"
            disabled={data.format === 'remeeting'}
            onChange={
            (event, eventData) => { updateDataField('time_stamps', eventData.checked); }
          }
            checked={data.time_stamps || false}
          />
        </Form.Field>
        <Form.Field>
          <Checkbox
            toggle
            disabled={data.format === 'remeeting'}
            label='Show confidence for each word in "transcript_raw"'
            onChange={
            (event, eventData) => { updateDataField('word_confidence', eventData.checked); }
          }
            checked={data.word_confidence || false}
          />
        </Form.Field>
        <Form.Field>
          <Checkbox
            toggle
            disabled={data.format === 'remeeting'}
            label='Show speaker label alongside "transcript"'
            onChange={
            (event, eventData) => { updateDataField('speaker_label_transcript', eventData.checked); }
          }
            checked={data.speaker_label_transcript || false}
          />
        </Form.Field>
        <Form.Field>
          <Checkbox
            toggle
            disabled={data.format === 'remeeting'}
            label='Show start and end times alongside "transcript"'
            onChange={
            (event, eventData) => { updateDataField('timestamp_transcript', eventData.checked); }
          }
            checked={data.timestamp_transcript || false}
          />
        </Form.Field>
        <Form.Field>
          <Checkbox
            toggle
            disabled={data.format === 'remeeting'}
            label="Render JSON with no unneccessary whitespace"
            onChange={
            (event, eventData) => { updateDataField('compact', eventData.checked); }
          }
            checked={data.compact || false}
          />
        </Form.Field>
      </div>
    );
  }

  /* Note this must be used inside a <Form> */
  render() {
    const { showOptionsControls } = this.state;
    return (
      <div id="j-outputFormatOptions" className="re is-marginTop-16px">
        <Button onClick={() => { this.toggleShowOptionsControls(); }}>
          { showOptionsControls ? 'Hide Output Options' : 'Show Output Options' }
        </Button>
        { showOptionsControls && this.renderOutputOptions() }
      </div>
    );
  }
}

FormOptionsFormatOutput.propTypes = {
  data: PropTypes.shape({
    compact: PropTypes.bool,
    format: PropTypes.string,
    speaker_labels: PropTypes.bool,
    speaker_label_transcript: PropTypes.bool,
    time_stamps: PropTypes.bool,
    timestamp_transcript: PropTypes.bool,
    word_confidence: PropTypes.bool,
    word_alternatives: PropTypes.bool,
    word_alternatives_threshold: PropTypes.bool,
  }).isRequired,
  updateDataField: PropTypes.func.isRequired,
};

export default FormOptionsFormatOutput;
